import type { TranslatedOption } from './types'

export function translatedOptionName(option: TranslatedOption, locale: string) {
  const name = option.nameTranslations.find((t) => t.locale === locale)

  return name?.value || option.name
}
